import { render, staticRenderFns } from "./PholderText.vue?vue&type=template&id=2a1058d4"
import script from "./PholderText.vue?vue&type=script&lang=js"
export * from "./PholderText.vue?vue&type=script&lang=js"
import style0 from "./PholderText.vue?vue&type=style&index=0&id=2a1058d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports